import React from 'react';
import WhatsThis from '../controls/whatsThis';
const FullTextSearchInstructions = () => {
  const dtStyle = {
    float: 'left'
  };
  const ddStyle = {
    float: 'left',
    textAlign: 'left'
  };
  const iStyle = {
    color: 'blue'
  };
  const searchHelperText = /*#__PURE__*/React.createElement("dl", {
    style: {
      padding: '5px'
    }
  }, /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Basic Search"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "All words are searched individually. For example, searching for \xA0", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "tall ladder"), " will find results with either", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "tall"), " or ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "ladder"), "."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Phrase Search"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Wrap in double quotes. For example, searching for \xA0", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "\"second coat finished\""), " will return results that match exactly that phrase."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Wildcard Search"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Use an asterisk. For example, searching for ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "item*"), " will return results that contain ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "items"), " and ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "itemized"), ".", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Asterisks can also be used at the beginning of a string to find partial words. For example, searching for ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "*tem"), " will return results that contain ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "items"), " and ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "itemized"), ". With leading wildcard search it's important to note that, unlike trailing wildcards, the phrase following the wildcard will be used in its entirety rather than searching for each word independently."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Required Words"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Words that must appear can be marked with a leading ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "+"), ". For example, searching for ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "+completed"), " will only find results with", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "completed"), " as a term."), /*#__PURE__*/React.createElement("dt", {
    style: dtStyle
  }, "Excluded Words"), /*#__PURE__*/React.createElement("dd", {
    style: ddStyle
  }, "Words that must not appear can be marked with a leading ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "-"), ". For example, searching for ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "work -completed"), " will only find results that include ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "work"), ", but not ", /*#__PURE__*/React.createElement("i", {
    style: iStyle
  }, "completed"), "."));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      paddingRight: '5px'
    }
  }, "Search Help"), /*#__PURE__*/React.createElement(WhatsThis, {
    text: searchHelperText,
    title: "Search Options"
  }));
};
export default FullTextSearchInstructions;